export default __webpack_public_path__ + "static/media/team_ico.e0109c53.svg";